import axios from "axios";

const BASE = process.env.REACT_APP_WOW_SIGN_API_BASE_URL;

export const uploadDocument = (file, signMode = "BOTH", expiryDays = 7) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(
    `${BASE}/documents?signMode=${signMode}&expiryDays=${expiryDays}`,
    form
  );
};

export const addSignersBulk = (documentId, payload) =>
  axios.post(`${BASE}/documents/${documentId}/signers/bulk`, payload);

export const getSigners = (documentId) =>
  axios.get(`${BASE}/documents/${documentId}/signers`);

export const addField = (documentId, payload) =>
  axios.post(`${BASE}/documents/${documentId}/fields`, payload);

export const getProgress = (documentId) =>
  axios.get(`${BASE}/documents/${documentId}/progress`);

export const getDocuments = () =>
  axios.get(`${BASE}/documents`);

export const getDocumentSummary = (documentId) =>
  axios.get(`${BASE}/documents/${documentId}/summary`);

export const getDocumentPages = (documentId) =>
  axios.get(`${BASE}/documents/${documentId}/pages`);

export const getDocumentDownloadUrl = (documentId) =>
  `${BASE}/documents/${documentId}/download`;

export const sendInvite = (documentId, signerId) =>
  axios.post(`${BASE}/documents/${documentId}/signers/${signerId}/send-invite`);

export const sendReminder = (documentId, signerId) =>
  axios.post(`${BASE}/documents/${documentId}/signers/${signerId}/send-reminder`);

export const getAuditLogs = (documentId) =>
  axios.get(`${BASE}/documents/${documentId}/audit`);

export const createRevision = (documentId) =>
  axios.post(`${BASE}/documents/${documentId}/revision`);

export const getRevisionHistory = (documentId) =>
  axios.get(`${BASE}/documents/${documentId}/revisions`);

export const extendExpiry = (documentId, extraDays = 7) =>
  axios.post(`${BASE}/documents/${documentId}/extend-expiry?extraDays=${extraDays}`);

export const getAnalytics = () =>
  axios.get(`${BASE}/admin/analytics`);

export const getDropOffAnalytics = () =>
  axios.get(`${BASE}/admin/analytics/drop-offs`);

export const getSlaAnalytics = () =>
  axios.get(`${BASE}/admin/analytics/sla`);


export const getNotifications = () => axios.get(`${BASE}/admin/notifications`);

export const markNotificationRead = (notificationId) =>
  axios.post(`${BASE}/admin/notifications/${notificationId}/read`);

export const markAllNotificationsRead = () =>
  axios.post(`${BASE}/admin/notifications/read-all`);